import Image from 'next/image'
import { useTranslation } from 'next-i18next'
import { Icon } from '@captaincause/ui/Icon'
import field from 'assets/home-impact-field.webp'
import world from 'assets/home-world-point.webp'
import { Button } from 'components/Button'

export function Impacts() {
  const { t } = useTranslation('home.page')

  return (
    <section className="px-6 py-10 md:p-20">
      <h2 className="mb-4 text-center font-default text-2xl font-semibold leading-8 -tracking-[1.5px] md:mb-10 md:text-[34px] md:leading-[48px]">
        {t('impacts.title')}
      </h2>

      <div className="m-auto grid max-w-[1400px] grid-cols-1 gap-6 md:grid-cols-2 md:grid-rows-2">
        <div className="relative rounded-2xl border border-medium-gray p-6">
          <div className="flex flex-col gap-4">
            <div className="w-fit rounded-2xl bg-medium-purple p-2">
              <Icon icon="check-round" fill="fill-dark-purple" />
            </div>

            <h3 className="font-default text-lg font-semibold leading-8 -tracking-[0.5px] md:text-2xl">
              {t('impacts.card1.title')}
            </h3>
            <ul className="flex flex-col gap-5">
              <li className="flex list-none items-start self-start font-normal leading-7 text-dark-gray">
                <div className="mr-3 rounded-full bg-light-purple p-1">
                  <Icon icon="check" fill="fill-dark-purple" />
                </div>
                {t('impacts.card1.item1')}
              </li>
              <li className="flex list-none items-start self-start font-normal leading-7 text-dark-gray">
                <div className="mr-3 rounded-full bg-light-purple p-1">
                  <Icon icon="check" fill="fill-dark-purple" />
                </div>
                {t('impacts.card1.item2')}
              </li>
              <li className="flex list-none items-start self-start font-normal leading-7 text-dark-gray">
                <div className="mr-3 rounded-full bg-light-purple p-1">
                  <Icon icon="check" fill="fill-dark-purple" />
                </div>
                {t('impacts.card1.item3')}
              </li>
            </ul>
            <div className="flex flex-col items-center gap-4 sm:flex-row md:flex-col lg:flex-row">
              <Button
                href="/causes"
                variant="primary"
                className="rounded-full border-gray sm:h-auto sm:px-5 sm:py-2 md:px-7 md:py-3"
                innerClassName="text-center"
                locale={false}
              >
                {t('impacts.card1.cta-primary')}
              </Button>
              <Button
                href="/comite-impact"
                variant="secondary"
                className="rounded-full"
                innerClassName="text-center"
                locale={false}
              >
                {t('impacts.card1.cta-secondary')}
              </Button>
            </div>
          </div>
        </div>
        <div className="h-full">
          <Image
            src={field}
            alt="image"
            className="h-full rounded-2xl object-cover lg:max-h-[400px] lg:w-full"
          />
        </div>
        <div className="h-full overflow-hidden rounded-2xl bg-light-gray p-6">
          <div className="flex flex-col gap-4">
            <div className="w-fit rounded-2xl bg-medium-purple p-2">
              <Icon icon="compass" fill="fill-dark-purple" />
            </div>
            <h3 className="mb-4 font-default text-lg font-semibold leading-8 -tracking-[0.5px] md:text-2xl">
              {t('impacts.card3.title')}
            </h3>
            <Image
              src={world}
              alt="world-point"
              className="max-h-[160px] object-contain"
            />
          </div>
        </div>
        <div className="relative rounded-2xl border border-medium-gray p-6">
          <div className="flex flex-col gap-4">
            <div className="w-fit rounded-2xl bg-medium-purple p-2">
              <Icon icon="star" fill="fill-dark-purple" />
            </div>

            <h3 className="font-default text-lg font-semibold leading-8 -tracking-[0.5px] md:text-2xl">
              {t('impacts.card4.title')}
            </h3>
            <div>
              <div className="text-dark-gray">
                {t('impacts.card4.description')} <br />
                {t('impacts.card4.description-2')}
              </div>
            </div>
            <Button
              href="/projects"
              variant="secondary"
              className="rounded-full border-gray px-7 py-3"
              innerClassName="text-center"
              locale={false}
            >
              {t('impacts.card4.cta')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
